export enum MoreColors {
    DarkGrey = "#595959",
    LightBlack = "#262626",
    WhitishGrey = "#e8e8e8",
    LightBlue = "#C5E3FF",
    Grey = "#979797",
}
  